module.exports = __webpack_public_path__ + "static/media/mubon_compuesto.bc267f60.png";